<template>
    <common-page flex-column card-content>
        <query-view ref="queryView"
                    config-code="em_arch_fixed_asset_change"
                    disable-row-check
                    with-custom-actions-head-of-row
                    custom-columns="costCenterCode,newCostCenterCode">
            <template #custom(costCenterCode)="{row}">
                {{ costCenterText(row.costCenterCode, row.costCenterName) }}
            </template>
            <template #custom(newCostCenterCode)="{row}">
                {{ costCenterText(row.newCostCenterCode, row.newCostCenterName) }}
            </template>
            <template #headOfRow="{row}">
                <mini-button name="exportDetail"
                             :loading="exportingId === row.id"
                             :title="$t('label.em.asset.emArchFixedAssetChange.exportDetail')"
                             @btnClick="exportDetail(row)">
                    <i class="fa fa-fw fa-file-excel-o"></i>
                </mini-button>
            </template>
        </query-view>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import QueryView from "@/components/common/display/query-view/QueryView.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import {costCenterText} from "@/views/em/asset/costCenterText";

/**
 * 固定资产变更 | 查询页（验收 #9；URS 需求_new R24–R28）。
 * <p>
 * 列表与筛选全部来自 QueryView 配置 em_arch_fixed_asset_change
 * （src/model/em/asset/EmArchFixedAssetChange.jsc-import.json，service = em-archive）。
 * QueryView 的筛选条是由「可见列」自动派生的：
 *   变更日期 finishTime（Date → Between 区间）、当前处理人 currentHandlers（String → ILike）、
 *   变更类型 changeType（select → In）、资产状态 assetStatus（select → In）、
 *   固资号 assetNo（String → ILike）—— 正好覆盖 #9 要求的五项，无需另配筛选表。
 * <p>
 * 流程状态列用的是 status（BPMN task id）配静态选项，而不是 join
 * EM_ACT_PROCESS_DEFINITION_REGISTER_PDR + EM_ACT_PROCESS_STATUS 取 statusName：
 * 后者是运行时数据，缺行时整列会是空白且不报错。
 * <p>
 * 「原设备编码」「原成本中心」取的是单据上发起时的快照（equipment_code / cost_center_id），
 * 分别排在对应的「新」列前；原成本中心经第三个 MST_LOCATION 别名 EmAclDept__2 join 出<b>编码</b>，
 * 「新成本中心」同样显示编码（EmAclDept.code），两列并排可直接对比。
 * 两列可见即各自多出一个 ILike 筛选项（QueryView 的可见列即筛选条）。
 * <p>
 * Excel 导出用 QueryView 自带的导出按钮；行按钮「导出明细」打后端
 * GET /emArchFixedAssetChange/exportDetail?id=（节点 / 处理人 / 结果 / 备注 / 时间）。
 */
export default {
    name: "EmArchFixedAssetChangeQueryView",
    components: {MiniButton, QueryView, CommonPage},
    mixins: [emCommonUtilMixin],
    data() {
        return {
            exportingId: null,
        }
    },
    methods: {
        costCenterText,

        exportDetail(row) {
            if (!row || !row.id) {
                return;
            }
            this.exportingId = row.id;
            let fileName = `${row.workOrderCode || row.id}-${this.$t('label.em.asset.emArchFixedAssetChange.exportDetailFileName')}`;
            this.downloadWithHeader(
                    `${process.env.VUE_APP_EM_ARCHIVE_URL}/emArchFixedAssetChange/exportDetail?id=${row.id}`,
                    fileName,
                    (success, errorMsg) => {
                        this.exportingId = null;
                        if (!success) {
                            // 失败不用自己弹通用错误，这里只补上后端给的具体原因
                            this.$bvToast.toast(
                                    errorMsg || this.$t('label.em.asset.emArchFixedAssetChange.downloadFailed'), {
                                        variant: 'danger',
                                        noCloseButton: true,
                                        autoHideDelay: 4000
                                    });
                        }
                    });
        },
    }
}
</script>

<style scoped>
</style>
